import getSavedItems from "./getSavedItems";

const getSavedItemById = (state, itemId) => {
  const items = getSavedItems(state);

  return items.find(item => item.id === itemId);
};

export default getSavedItemById;
